import { useState } from 'react';

const NAV = [
  { href: '#ranking', label: '热度榜' },
  { href: '#feed', label: '今日快讯' },
  { href: '#sites', label: '站点导航' },
  { href: '#hot', label: '热门资源' },
  { href: '#night', label: '深夜片单' },
  { href: '#faq', label: '常见问题' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur border-b border-foreground-950/10">
      <div className="flex items-center justify-between h-14 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 group">
          <span className="w-2.5 h-2.5 rounded-full bg-primary-500" />
          <span className="font-heading font-black text-xl tracking-tight text-foreground-950">小电影</span>
          <span className="hidden sm:inline text-[11px] tracking-[0.2em] text-foreground-500 font-label ml-1 border-l border-foreground-950/15 pl-2">
            看片导航
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 h-9 pl-3 pr-2 rounded-md border border-foreground-950/15 bg-background-100/70 focus-within:border-primary-400 transition-colors">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-500" />
            </span>
            <input
              type="text"
              placeholder="搜站点 / 片名"
              className="w-28 lg:w-36 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
          </div>
          <a
            href="#sites"
            className="hidden sm:inline-flex items-center h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer dark:text-foreground-950"
          >
            开始看片
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-foreground-950/15 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-foreground-950/10 bg-background-50 px-4 py-2">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm text-foreground-700 border-b border-foreground-950/5 last:border-0 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}